import { useState, useEffect } from "react";
import {useLocation} from "react-router-dom"

const CustomerSelector = ({customersOfUser, handleSelect, defaultCustomer}) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const location = useLocation()
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [isShortened, setIsShortened] = useState(window.innerWidth <= 991);

    useEffect(() => {
        setDropdownOpen(false);
    }, [location.pathname]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
            setIsShortened(window.innerWidth <= 991);
        };
        window.addEventListener("resize", handleResize);
        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const customersBusinessNamesWithoutRepetitions = [...new Set(customersOfUser.map(customer => customer.businessName))];

    const handleSelectCustomer = (businessName) => {
        handleSelect(businessName)
        setDropdownOpen(false)
    }

    return (
        <li className={`dropdown ${dropdownOpen ? "open" : ""}`} onClick={() => setDropdownOpen(!dropdownOpen)} style={{
            position: "relative", 
            zIndex: 3,
            margin: 0,
            padding: 0,
            listStyle: "none",
            display: "flex",
            alignItems: "center",
            height: "100%"
        }}>
            <a href="#" className="dropdown-toggle" tabIndex="-10" style={{
                fontFamily: 'ArcherSmbd, sans-serif', 
                fontWeight: 'bold',
                fontSize: '18px',
                display: 'flex',
                alignItems: 'center',
                height: "100%",
                padding: 0
            }}>
                {isShortened? "Cliente" : `${defaultCustomer.businessName}`} <span className="caret" ></span>
            </a>
            {dropdownOpen && (
                <ul className="dropdown-menu" style={ 
                    isMobile? {
                        position: "absolute", 
                        left: '57%', 
                        alignItems: 'center',
                        zIndex: 1051,
                        marginTop: '5px',
                        minWidth: '200px'
                    } : isShortened? {
                        position: "absolute",
                        zIndex: 1051,
                        marginTop: '5px',
                        right: 0,
                        minWidth: '200px'
                    } : {
                        zIndex: 1051,
                        marginTop: '5px',
                        right: 0,
                        minWidth: '200px'
                    }}>
                    {customersBusinessNamesWithoutRepetitions.map((businessName, index) => (
                        <li key={index} onClick={() => handleSelectCustomer(businessName)}>
                            <a href="#" tabIndex="-10" style={{ fontWeight: businessName === defaultCustomer.businessName? 'bold' : 'normal' }}>{businessName}</a>
                        </li>
                    ))}
                </ul>
            )}
        </li>
    );
};

export default CustomerSelector;

